<template>
	<div
		class="lost-connection"
		data-cy="lost-connection"
	>
		<helio-modal
			:active="showModal"
			:state="state"
			:title="$t('lost-connection.title')"
			class="lost-connection__modal"
			data-cy="lost-connection-modal"
			@close="showModal = false"
		>
			<template v-slot:content>
				{{ $t('lost-connection.message') }}
			</template>

			<template v-slot:footer>
				<helio-button
					:text="$t('lost-connection.close')"
					color="normal-outline"
					@click="close"
				/>

				<helio-button
					:text="$t('lost-connection.reload')"
					:color="buttonColor"
					@click="reload"
				/>
			</template>
		</helio-modal>
	</div>
</template>

<script>
import Button from '../button/Button.vue';
import Modal from '../modal/Modal.vue';

export default {
	name: 'LostConnection',

	components: {
		'helio-button': Button,
		'helio-modal': Modal,
	},

	props: {
		active: {
			type: Boolean,
			required: false,
			default: false,
			description: 'Allows the modal to be forcefully opened by its parent',
		},

		state: {
			type: String,
			required: false,
			default: 'alert',
			validator: value => [
				'alert',
				'danger',
				'info',
				'normal',
				'success',
			].indexOf(value) !== -1,
			description: 'Sets the state of the Modal',
		},
	},

	data() {
		return {
			showModal: false,
		};
	},

	computed: {
		buttonColor() {
			return this.state === 'normal' ? 'primary' : this.state;
		},
	},

	watch: {
		active(newVal) {
			this.showModal = newVal;
		},

		showModal(newVal) {
			if (newVal) {
				this.$emit('open');
			} else {
				this.$emit('close');
			}
		},
	},

	mounted() {
		window.addEventListener('online', this.onOnlineEvent);
		window.addEventListener('offline', this.onOfflineEvent);
	},

	beforeDestroy() {
		window.removeEventListener('online', this.onOnlineEvent);
		window.removeEventListener('offline', this.onOfflineEvent);
	},

	methods: {
		close() {
			this.showModal = false;
		},

		reload() {
			this.$router.go();
		},

		onOnlineEvent() {
			this.showModal = false;
			this.$emit('online');
		},

		onOfflineEvent() {
			this.showModal = true;
			this.$emit('offline');
		},
	},
};
</script>

<style lang="scss" src="./lost-connection.scss" />
